import axios from "axios";
import dayjs from "dayjs";

export function assignTemplate(body) {
    // body: { machineId, weekTemplateId, validFrom, validTo }
    return axios.post("api/productioncalendar/assign-template", body);
}

export function removeAssignedTemplate(body) {
    // body: { machineId, validFrom, validTo }
    return axios.post("api/productioncalendar/remove-assigned-template", body);
}

export const getShiftByShift = async(companyKey, fromDate, toDate, machineId) =>{

    fromDate = dayjs(fromDate).format("YYYY-MM-DDTHH:mm:ss");
    toDate = dayjs(toDate).format("YYYY-MM-DDTHH:mm:ss");
    return await axios.get(`api/productioncalendar/shift-by-shift?companyKey=${companyKey}&fromDate=${fromDate}&toDate=${toDate}`);
};

